/*
Reducers:
Tell to  how the state of our application should  whenever a given action occurs
*/
/*initial Value, action thet produce call to this reducer*/


import moment from "moment";

export const numberOfClicksReducer = (state = 0, action) => {
    const { type } = action;

    switch (type) {
        case 'COUNTER_BUTTON_CLICKED':
            return state + action.payload.amount;
        default:
            return state;
    }
}



const initialStateAppGlobal = {
    localtime: true, //Indica si por defecto se muestra la hora local
    timezone: moment.tz.guess(), //process.env.REACT_APP_TIME_ZONE, hora por defecto 
    locale: "en",
    rsc: "",
    competition: 'NONE',
    discipline: "NONE",
    event: "",
    phase: "",
    date: "",
    legends: { data: [], status: 0 },
    components: {
        phaseSelector: {
            elementSelected: "",
            eventUnitExpanded: false
        }
    },
    intermediateSelector: {
        isLive: true,
        current: null,
        selected: null,
        finalPosition: null

    }


}

export const appGlobalReducer = (state = initialStateAppGlobal, action) => {

    const { type } = action;
    switch (type) {
        case 'CHANGE_TIMEZONE':
            return Object.assign({}, state, {
                localtime: action.payload.localtime,
                timezone: action.payload.localtime ? moment.tz.guess() : process.env.REACT_APP_TIME_ZONE

            });
        case 'CHANGE_COMPETITION':
            return Object.assign({}, state, {
                competition: action.payload.competition
            });

        case 'CHANGE_RSC':
            return Object.assign({}, state, {
                rsc: action.payload.rsc
            });


        case 'CHANGE_DAY':
            return Object.assign({}, state, {
                date: action.payload.day
            });

        case 'CHANGE_EVENT':
            return Object.assign({}, state, {
                event: action.payload.event
            });

        case 'CHANGE_PHASE':
            return Object.assign({}, state, {
                phase: action.payload.phase
            });

        case 'CHANGE_LOCALE':
            return Object.assign({}, state, {
                locale: action.payload.locale
            });

        case 'COMPONENT_PHASESELECTOR_CHANGE_PHASE':
            return Object.assign({}, state, {
                components: {
                    phaseSelector: {
                        elementSelected: action.payload.phase
                    }
                }
            });
        case 'COMPONENT_PHASESELECTOR_CHANGE_EXPANDED':
            return Object.assign({}, state, {
                components: {
                    phaseSelector: {
                        eventUnitExpanded: action.payload.expanded
                    }
                }
            });

        case 'COMPONENT_INTERMEDIATESELECTOR_CHANGE':
            return Object.assign({}, state, {
                intermediateSelector: action.payload.intermediateSelector
            });

        case 'COUNTER':
            return state + action.payload.amount;


        case 'ADD_LEGEND':
            console.log("Status:" + state.legends.status)
            if (state.legends.status === 0) {

                const legends = state.legends.data
                let resp = false
                Array.isArray(legends) && legends.some(element => {
                    if (element.id === action.payload.legend.id) {
                        resp = true;
                    }
                });

                if (resp) {
                    return Object.assign({}, state, {

                        legends: { data: state.legends.data, status: 0 }

                    });

                }



                /*return Object.assign({}, state, {
                    legends: { data: [...state.legends.data, action.payload.legend], status: 0 }

                });*/

                console.log("Add NEW: " + JSON.stringify(action.payload.legend))
                return { ...state, legends: { data: [...state.legends.data, action.payload.legend], status: 0 } }

            } else {
                console.log("Add INIT")

                return Object.assign({}, state, {

                    legends: { data: [action.payload.legend], status: 0 }

                });

            }
        case 'REMOVE_ALL_LEGENDS':
            console.log("Remove Legends")
            return Object.assign({}, state, {
                //legends: { data: [...state.legends.data], status: 1 }
                legends: { data: [], status: 1 }
            });

        default:
            return state;

    }

}